import { BaseConverter } from "./base.converter";
import { ContactDto } from "@dtos/contact.dto";
import { Contact } from "@models/contact.model";

export class ContactConverter extends BaseConverter <Contact,ContactDto>{

    modelToDto(model: Contact): ContactDto {    
        return new ContactDto(
            model.whatsapp,
            model.telephoneNumber,    
            model.mobileNumber,
            model.email,
            model.website,
            model.airbnb,
            model.booking,
            model.facebook,
            model.instagram,
            model.youtube,
            model.tiktok,
            model.otherWebsites
        )
    }   
    dtoToModel(dto: ContactDto): Contact {
        return new Contact(
            dto.whatsapp,
            dto.telephoneNumber,
            dto.mobileNumber,
            dto.email,
            dto.website,
            dto.airbnb,
            dto.booking,
            dto.facebook,
            dto.instagram,
            dto.youtube,
            dto.tiktok,
            dto.otherWebsites 
        )
    }
}